import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";
import client, { saveAuth } from "@/lib/api";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GoogleCallback = () => {
  const location = useLocation();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login", { replace: true }); return; }

    const ref = sessionStorage.getItem("k_pending_ref") || "";
    sessionStorage.removeItem("k_pending_ref");

    (async () => {
      try {
        const { data } = await client.post("/auth/google/session", { session_id: sessionId, ref });
        saveAuth(data.access_token, data.user);
        // Clear the fragment
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(data.new_user ? "Account created via Google" : "Welcome back");
        nav("/dashboard", { replace: true });
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav]);

  return (
    <div className="min-h-screen bg-[#0A0D14] text-white flex items-center justify-center noise">
      <div className="text-center">
        <BrandLogo height={64} className="mx-auto mb-4" />
        <div className="font-mono-k tracking-widest-k text-[#FACC15] text-xs mb-2">— AUTHENTICATING</div>
        <div className="font-display text-2xl tracking-tighter">Signing you in…</div>
      </div>
    </div>
  );
};

export default GoogleCallback;
